// extracted by mini-css-extract-plugin
module.exports = {"chart":"NetworkDemographics_chart__cD5zz"};